import { useState } from "react";
import { faqs, guideSteps } from "@/mocks/homeData";
import SectionHeading from "./SectionHeading";

export default function GuideSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="guide" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <SectionHeading
          eyebrow="阅读指南"
          title="三步找到你想看的部分"
          desc="如果你刚接触这个题材，或者面对一堆分类不知道从哪下手，按下面三步走基本不会迷路。"
        />

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {guideSteps.map((step) => (
            <div key={step.step} className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
              <span className="font-heading text-3xl font-bold text-accent-500">{step.step}</span>
              <h3 className="mt-3 font-heading text-lg font-semibold text-foreground-950">{step.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-12 gap-6 md:gap-10">
          <div className="lg:col-span-4">
            <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">常见问题</h3>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              关于本站能做什么、小说漫画同人的区别，以及第二季与续集的查找方式，这里是出现频率最高的几个疑问。
            </p>
          </div>

          <div className="lg:col-span-8 space-y-3">
            {faqs.map((faq, index) => {
              const open = openIndex === index;
              return (
                <div
                  key={faq.q}
                  className={`rounded-lg border transition-colors ${
                    open ? "border-primary-300 bg-primary-50" : "border-background-200 bg-background-100"
                  }`}
                >
                  <button
                    type="button"
                    aria-expanded={open}
                    onClick={() => setOpenIndex(open ? null : index)}
                    className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className="font-medium text-sm md:text-base text-foreground-950">{faq.q}</span>
                    <span
                      className={`shrink-0 w-7 h-7 flex items-center justify-center rounded-full text-base ${
                        open ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      <i className={open ? "ri-subtract-line" : "ri-add-line"}></i>
                    </span>
                  </button>
                  <div className={open ? "px-5 pb-4" : "hidden"}>
                    <p className="text-sm leading-relaxed text-foreground-600">{faq.a}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}